import React from "react";
import Modal from "react-bootstrap/Modal";

const SuccessAssignModal = (props) => {
  return (
    <>
      <Modal
        {...props}
        // size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="main-success-modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="success-button">
            <p>Engineer Assign Successfully</p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SuccessAssignModal;
